import { useRef } from "react";
import Button from "../ui/Button";
import { useGSAP } from "@gsap/react";
import gsap from "gsap";
import useFormStore from "../../stores/FormStore.jsx";
import LinkLikeButton from "../ui/LinkLikeButton";

const ServicesPricing = ({title ,items, desc, cta_text, cta_button, lang, menu}) => {
    const lineRef = useRef(null);
    const markerRef = useRef(null);
    const itemsRef = useRef([]);
    const itemsWrappersRef = useRef([])

    const sectionRef = useRef(null)
    const bottomSection = useRef(null)
    const titleRef = useRef(null)
    const textRef = useRef(null)
    const bottomTextRef = useRef(null)
    const buttonRef = useRef(null)

    const {openPopUp, setOpenPopUp} = useFormStore();

    useGSAP(() => {


        const mm = gsap.matchMedia();

        mm.add("(min-width: 1280px)", () => {


            gsap.fromTo(titleRef.current, {opacity: 0}, {
                opacity: 1,

                duration: 1,
                scrollTrigger: {
                    trigger: sectionRef.current,
                    start: "top 80%",
                },
            });

            gsap.fromTo(textRef.current, {opacity: 0}, {
                opacity: 1,
                duration: 1,
                scrollTrigger: {
                    trigger: sectionRef.current,
                    start: "top 80%",
                },
            });


            gsap.fromTo(bottomTextRef.current, {opacity: 0}, {
                opacity: 1,
                duration: 1,
                scrollTrigger: {
                    trigger: bottomSection.current,
                    start: "top 85%",
                },
            });


            gsap.fromTo(buttonRef.current, {opacity: 0}, {
                opacity: 1,
                duration: 1,
                scrollTrigger: {
                    trigger: bottomSection.current,
                    start: "top 85%",
                },
            });

        })


        gsap.fromTo(
            lineRef.current.querySelector(".progress"),
            {height: 0, backgroundColor: '#B4A774'},
            {
                height: "100%",
                backgroundColor: 'black',
                ease: "none",
                scrollTrigger: {
                    trigger: lineRef.current,
                    start: "top 80%",
                    end: "bottom 80%",
                    scrub: true,
                },
            }
        );

        gsap.fromTo(
            markerRef.current,
            {top: 0, scale: 1, y: 0},
            {
                top: "100%",
                scale: 0,
                y: '-0.6rem',
                ease: "none",
                scrollTrigger: {
                    trigger: lineRef.current,
                    start: "top 80%",
                    end: "bottom 80%",
                    scrub: true,
                },
            }
        );

        itemsRef.current.forEach((el, i) => {
            gsap.to(el, {
                opacity: 1,
                duration: 0.1,
                ease: "none",
                scrollTrigger: {
                    trigger: lineRef.current,
                    start: "top 80%",
                    end: "bottom 80%",
                    scrub: true,
                    onUpdate: (self) => {
                        const progress = self.progress;
                        const total = itemsRef.current.length;
                        const step = 1 / total;

                        if (progress >= i / itemsRef.current.length) {
                            el.style.opacity = "1";
                            el.style.transform = "scale(1.1)";
                        } else {
                            el.style.opacity = "0.4";
                            el.style.transform = "scale(1)";
                        }

                        // const startRange = i * step;
                        // const endRange = (i + 1) * step;
                        // const isActive = progress >= startRange - 1;

                        // if (isActive) {
                        //   el.style.transform = "scale(1.1)";
                        // } else {
                        //   el.style.transform = "scale(1)";
                        // }
                    },
                },
            });
        });
    }, {scope: sectionRef});

  return (
    <section ref={sectionRef} className="container-max overflow-hidden container-padding py-[4rem] flex-col md:py-[5rem] lg:py-[6rem] xl:py-[8rem] w-full relative">
      <div className="mb-[3.2rem] md:mb-[4rem]">
        <h2 ref={titleRef} dangerouslySetInnerHTML={{__html: title}} className="heading-3 mb-[1.6rem] md:mb-[2rem] [&>.selected]:italic [&>.selected]:text-dusty-green-dark"/>
        <p ref={textRef} className="text-1 lg:max-w-[37rem]">
          {desc}
        </p>
      </div>

      <div className="w-full mb-[3.2rem] lg:mb-[4rem] xl:mb-[8rem] relative">
        <div
          ref={lineRef}
          className="w-[1px] h-full absolute left-0 lg:left-1/2 top-0 bg-dusty-green-dark-10"
        >
          <div className="progress z-10 relative w-full bg-dusty-green-dark"></div>
          <div
            ref={markerRef}
            className="absolute bg-dusty-green-dark -translate-x-1/2 z-10 w-[1.2rem] h-[1.2rem] left-1/2 top-0 "
          ></div>
        </div>

        <div className="pl-[4rem] lg:pl-0 flex  flex-col gap-[3.2rem]">
          {items?.map((item, index) => (
            <div key={index} className={` w-full lg:flex lg:flex-col lg:items-center`}>
              <div ref={(el) => (itemsWrappersRef.current[index] = el)} className={`${index % 2 !== 0 ? 'lg:text-left lg:ml-[62.5rem] xl:ml-[65rem]' : 'lg:mr-[62.5rem] xl:mr-[65rem] lg:text-right'}`}>
                <p className="heading-4 text-dusty-blue-light mb-[1.2rem] opacity-40">{'0' + (index + 1)}</p>
                <h3
                  ref={(el) => (itemsRef.current[index] = el)}
                  className={`heading-4 transition-[transform,opacity] ${index % 2 !== 0 ? 'lg:origin-left' : 'lg:origin-right'} origin-left max-w-[60rem] lg:w-[50rem] opacity-40 duration-300`}
                >
                  {item.title}
                </h3>
              </div>
            </div>
          ))}
        </div>
      </div>

        <div ref={bottomSection} className="flex flex-col lg:text-center items-center md:items-start lg:items-center">
            <p ref={bottomTextRef} className=" text-1 mb-[3.2rem] xl:mb-[4rem] max-w-[46.1rem] xl:max-w-[59rem]">
                {cta_text}
            </p>
            <div ref={buttonRef}>
                {lang === 'en' ? (menu && (
                    <LinkLikeButton trianglesColorClass={'bg-sky-blue'} className="w-fit" isFullSized={true} href={menu?.link}>
                        {cta_button}
                        <svg className="inline-block" width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 7H12M12 7L6 1M12 7L6 13" stroke="CurrentColor"/></svg>
                    </LinkLikeButton>
                    )) : (
                    <Button onClick={() => {setOpenPopUp(true)}} isFullSized={true}>
                        {cta_button}
                        <svg className="inline-block" width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 7H12M12 7L6 1M12 7L6 13" stroke="CurrentColor"/></svg>
                    </Button>
                )}
            </div>
        </div>
    </section>
  );
};

export default ServicesPricing;
